import React, { useState } from 'react';
import { TableCell } from '@mui/material';
import { haveIgnoreElement } from '@/main/services/utils';
import ModalTireBrand from '../../modalTireBrand/modalTireBrand';
import * as S from './styles';
import { TireBrandResponse } from '@/main/models/response/tireBrandResponse';
import StatusActiveGeneralComponent from '@/main/components/shared/status/statusActiveGeneral';
import { StatusActiveGeneralEnum } from '@/main/services/enum/StatusActiveGeneralEnum';

interface IRowDataTireBrandProps {
  tireBrand: TireBrandResponse;
  refreshSearchGrid: () => void;
}

function RowDataTireBrand({
  tireBrand,
  refreshSearchGrid
}: IRowDataTireBrandProps) {
  const [isOpenModalTireBrand, setIsOpenModalTireBrand] =
    useState<boolean>(false);

  function handleClickRow(
    e: React.MouseEvent<HTMLTableRowElement, MouseEvent>
  ) {
    if (haveIgnoreElement(e.target as HTMLElement)) return;
    setIsOpenModalTireBrand(true);
  }

  return (
    <>
      <S.Container $isSizeLong onClick={handleClickRow}>
        <TableCell>
          <S.CustomColumn title={tireBrand.description}>
            {tireBrand.description}
          </S.CustomColumn>
        </TableCell>
        <TableCell>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <StatusActiveGeneralComponent
              status={
                tireBrand.active
                  ? StatusActiveGeneralEnum.Active
                  : StatusActiveGeneralEnum.Inactive
              }
            />
          </div>
        </TableCell>
      </S.Container>

      <ModalTireBrand
        itemTireBrand={tireBrand}
        isOpenModal={isOpenModalTireBrand}
        refreshSearchGrid={refreshSearchGrid}
        closeModal={() => setIsOpenModalTireBrand(false)}
        setIsOpenModal={setIsOpenModalTireBrand}
      />
    </>
  );
}

export default RowDataTireBrand;
